import { Const } from 'auth-common/shared';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { useCallback } from 'react';

export const GNAVI_WIDTH_DEFAULT = 240;
export const GNAVI_WIDTH_MIN = 200;
export const GNAVI_WIDTH_MAX = 480;

const clamp = (px: number) => Math.min(GNAVI_WIDTH_MAX, Math.max(GNAVI_WIDTH_MIN, px));

export const gnaviWidthAtom = atomWithStorage<number>(Const.LocalStorage.GnaviWidth, GNAVI_WIDTH_DEFAULT, undefined, {
  getOnInit: true,
});

export const useGnaviWidth = () => {
  const [rawWidth, setRawWidth] = useAtom(gnaviWidthAtom);
  const setGnaviWidth = useCallback(
    (px: number) => {
      setRawWidth(clamp(px));
    },
    [setRawWidth],
  );
  return { gnaviWidth: clamp(rawWidth), setGnaviWidth };
};
